/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormLabel = styled(Form.Label)`
  font-size: 14px;
  padding-top: 2%;
  color: ${(props) => props?.color};
  font-weight: 600;
`;

export const FormSubtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
`;
